import { MedicalPaOrdersAlgoliaTableColumnKeys } from "./medicalPaOrdersTable";

/**
 * Updates the checkbox selection status for table rows within the visible page range.
 * Only applies when user is an admin. Returns early if not admin or if data is empty.
 *
 * Rows within the startIndex-endIndex range will have their isChecked status updated
 * based on whether the current page is in the pagesForWhichSelectAllIsEnabled list.
 * Rows outside the range preserve their existing isChecked status.
 *
 * @param isAdmin - Whether the current user is an admin
 * @param data - The table data array to update
 * @param startIdx - The starting index of the visible page range
 * @param endIdx - The ending index of the visible page range
 * @param currentPage - The current page number
 * @param enabledPages - Array of page numbers where select all is enabled
 */
export const updateTableDataWithSelectAllStatus = (
  isAdmin: boolean,
  data: any[],
  startIdx: number,
  endIdx: number,
  currentPage: number,
  enabledPages: number[],
  setTableData: (data: any[]) => void,
): void => {
  // Only apply select all logic for admin users
  if (!isAdmin) return;

  // Skip if no data
  if (!data || data.length === 0) return;

  const updatedData = data.map((row: any, index: number) => {
    // Only modify checkbox status for rows within the startIndex and endIndex range
    if (index >= startIdx && index <= endIdx) {
      return {
        ...row,
        [MedicalPaOrdersAlgoliaTableColumnKeys.SELECT]: {
          ...row[MedicalPaOrdersAlgoliaTableColumnKeys.SELECT],
          isChecked: enabledPages.includes(currentPage),
        },
      };
    }
    // For rows outside the range, preserve all existing data including isChecked status
    return row;
  });

  setTableData(updatedData);
};
